// extracted by mini-css-extract-plugin
module.exports = {"link":"marqueeComp-module--link--2to3P","marqueeWrapper":"marqueeComp-module--marqueeWrapper--1MZ-s","items":"marqueeComp-module--items--2PNwP"};